import {extendTheme} from '@chakra-ui/react';

// CSS variables also theme the older Tailwind and plain-CSS admin screens.
const purple = {50: '#fcf2fb', 100: '#f5d9f1', 200: '#ebb3e4', 300: '#df89d5', 400: '#ca5cbd', 500: '#ae309f', 600: '#88087b', 700: '#700665', 800: '#57054e', 900: '#390333'};
export const adminTheme = extendTheme({
  config: {initialColorMode: 'light', useSystemColorMode: false},
  colors: {purple, blue: purple},
  shadows: {outline: '0 0 0 3px var(--admin-accent)'},
  semanticTokens: {colors: {
    'admin.canvas': 'var(--admin-bg)',
    'admin.surface': 'var(--admin-surface)',
    'admin.subtle': 'var(--admin-subtle)',
    'admin.text': 'var(--admin-text)',
    'admin.muted': 'var(--admin-muted)',
    'admin.accent': 'var(--admin-accent)',
    'admin.selected': 'var(--admin-selected)',
    'admin.successBg': 'var(--admin-success-bg)',
    'admin.successText': 'var(--admin-success-text)',
    'admin.eventBg': 'var(--admin-event-bg)',
  }},
  styles: {global: {
    body: {bg: 'admin.canvas', color: 'admin.text'},
    '*': {borderColor: 'var(--admin-border)'},
    'a': {color: 'admin.accent'},
    '::placeholder': {color: 'admin.muted', opacity: 1},
  }},
  components: {
    Link: {baseStyle: {color: 'admin.accent'}},
    Button: {variants: {
      link: {color: 'admin.accent'},
      solid: (props: {colorScheme: string}) => ['purple', 'blue'].includes(props.colorScheme)
        ? {bg: 'purple.600', color: 'white', _hover: {bg: 'purple.700'}, _active: {bg: 'purple.800'}} : {},
    }},
    Input: {defaultProps: {focusBorderColor: 'admin.accent'}},
    Select: {defaultProps: {focusBorderColor: 'admin.accent'}},
    Textarea: {defaultProps: {focusBorderColor: 'admin.accent'}},
    Table: {
      baseStyle: {th: {color: 'admin.muted'}},
      variants: {
        simple: {th: {color: 'admin.muted'}},
        striped: {th: {color: 'admin.muted'}, tbody: {tr: {'&:nth-of-type(odd)': {td: {bg: 'admin.subtle'}}}}},
      },
    },
    Modal: {baseStyle: {dialog: {bg: 'admin.surface', color: 'admin.text'}}},
    Menu: {baseStyle: {list: {bg: 'admin.surface', color: 'admin.text'}}},
  },
});
